import React from 'react';
import styled, { css } from 'styled-components';

const Feature = ({ number, children, Icon, isMobile, ...rest }) => (
  <StyledFeature value={number} isMobile={isMobile} {...rest}>
    <StyledWrapper isMobile={isMobile}>
      <Icon isMobile={isMobile} />
      <StyledContent isMobile={isMobile}>{children}</StyledContent>
    </StyledWrapper>
  </StyledFeature>
);

const StyledFeature = styled.div`
  position: relative;
  display: flex;

  min-height: ${(props) => (props.isMobile ? '85px' : '275px')};
  align-items: center;

  &::before {
    position: absolute;
    left: ${(props) => (props.isMobile ? '20px' : '10px')};
    font-size: ${(props) => (props.isMobile ? '196px' : '328px')};
    line-height: 0.7;
    font-weight: 500;
    content: '${(props) => props.value}';
    color: ${(props) => props.theme.colors.white};
  }

  * {
    z-index: 2;
  }
`;
const StyledContent = styled.div`
  max-width: 170px;
  font-size: 18px;
  color: ${(props) => props.theme.colors.blackBase};

  ${(props) =>
    props.isMobile &&
    css`
      max-width: 125px;
      font-size: 13px;
    `}
`;

const StyledWrapper = styled.div`
  margin-top: 45px;
  display: flex;
  align-items: center;

  ${(props) =>
    props.isMobile &&
    css`
      margin-top: 25px;
      margin-left: 25px;
    `};
`;

export default Feature;
